import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from './components/login/login.component';
import {DashboardComponent} from './components/dashboard/dashboard.component';
import {LicitacoesComponent} from './components/licitacoes/licitacoes.component';
import {
  LicitacaoListSimpleComponent
} from './components/licitacao-list-simple/licitacao-list-simple.component';
import {LicitacaoEditComponent} from './components/licitacao-edit/licitacao-edit.component';
import {
  ListagemContratoComponent
} from './components/contrato/listagem-contrato/listagem-contrato.component';
import {
  LicitacaoGetOneRouterParamMatcher
} from "./components/licitacao-get-one/router-param-matcher/licitacao-get-one-router-param-matcher";
import {LicitacaoGetOneComponent} from "./components/licitacao-get-one/licitacao-get-one.component";
import {
  ContratoByNumeroContratoRouterParamMatcher
} from "./components/contrato/contrato-by-numerocontrato/router-param-matcher/licitacao-get-one-router-param-matcher";
import {
  ContratoByNumerocontratoComponent
} from "./components/contrato/contrato-by-numerocontrato/contrato-by-numerocontrato.component";

const routes: Routes = [
  {path: '', redirectTo: '/login', pathMatch: 'full'},
  {path: 'login', component: LoginComponent},
  {
    path: 'dashboard',
    component: DashboardComponent,
    children: [
      {path: 'licitacao', component: LicitacoesComponent},
      {path: 'licitacao/list', component: LicitacaoListSimpleComponent},
      {path: 'licitacao/edit/:id', component: LicitacaoEditComponent}
    ]
  },
  {path: 'licitacoes', component: LicitacaoListSimpleComponent},
  {path: 'contratos', component: ListagemContratoComponent},
  {path: 'licitacoes/avisos', redirectTo: `/licitacoes?tipoDeDocumento=Aviso%20de%20licitação`},
  // path: 'licitacoes/:modalidade/:numero/:orgao'
  {component: LicitacaoGetOneComponent, matcher: LicitacaoGetOneRouterParamMatcher},
  // path: 'contratos/:numero_contrato'
  {
    component: ContratoByNumerocontratoComponent,
    matcher: ContratoByNumeroContratoRouterParamMatcher
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts